import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { GridContainer } from '@lusha-ui/core';
import { ChevronDownIcon, ChevronUpIcon } from '@lusha-ui/icons';
import React, { useState } from 'react';
import Scripts from './scripts/Scripts';
function DevUI() {
    const [isOpened, setIsOpened] = useState(false);
    return (_jsxs("div", { css: css `
        position: fixed;
        top: 0;
        left: 30px;
        z-index: 20;
      `, children: [_jsx(GridContainer, { justifyContent: 'center', onClick: () => setIsOpened(val => !val), css: css `
          //height: 16px;
          cursor: pointer;
          //background: #fdbcfc;
          background: #fde0fd;
          width: 50px;
        `, children: isOpened ? _jsx(ChevronUpIcon, {}) : _jsx(ChevronDownIcon, {}) }), isOpened && _jsx(Scripts, { onClose: () => setIsOpened(false) })] }));
}
export default DevUI;
